module.exports = __webpack_public_path__ + "img/close-filter.751f3c9b.svg";